 // recargo de equivalencias
(() => {
  const recargoVariantId = Number(window.__recargoVariantId);
  const isReCustomer = Boolean(window.__isReCustomer);

  if (!recargoVariantId) return;

  let running = false;
  let lastRun = 0;

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return await res.json();
  }

  async function addRecargo() {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [{ id: recargoVariantId, quantity: 1 }] }),
    });

    if (!res.ok) {
      const txt = await res.text();
      console.error("[RE] Error add.js:", res.status, txt);
      return false;
    }
    return true;
  }

  async function changeLine(lineKey, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineKey, quantity }),
    });

    if (!res.ok) {
      const txt = await res.text();
      console.error("[RE] Error change.js:", res.status, txt);
      return false;
    }
    return true;
  }

  async function ensureRecargoLine() {
    const now = Date.now();
    if (running) return;
    if (now - lastRun < 1200) return; // evita bucles
    lastRun = now;

    running = true;
    try {
      const cart = await fetchCart();

      const recargoItem = cart.items.find((i) => i.variant_id === recargoVariantId);
      const hasOtherItems = cart.items.some((i) => i.variant_id !== recargoVariantId);

      // Si el carrito está vacío o solo tiene recargo, quitamos recargo si existe
      if (!hasOtherItems) {
        if (recargoItem) {
          const ok = await changeLine(recargoItem.key, 0);
          if (ok) location.reload();
        }
        return;
      }

      // Si NO es cliente RE: quitar recargo si existe
      if (!isReCustomer) {
        if (recargoItem) {
          const ok = await changeLine(recargoItem.key, 0);
          if (ok) location.reload();
        }
        return;
      }

      // Si es cliente RE: asegurar que exista 1 unidad
      if (!recargoItem) {
        const ok = await addRecargo();
        if (ok) location.reload();
        return;
      }

      if (recargoItem.quantity !== 1) {
        const ok = await changeLine(recargoItem.key, 1);
        if (ok) location.reload();
        return;
      }
    } finally {
      running = false;
    }
  }

  // 1) al cargar página
  document.addEventListener("DOMContentLoaded", ensureRecargoLine);

  // 2) cuando el DOM cambia (drawer / refresh AJAX)
  let t = null;
  const obs = new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(() => {
      // solo intentamos si hay algo de carrito pintado
      if (document.querySelector("[data-cart-item-list]")) {
        ensureRecargoLine();
      }
    }, 200);
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });

  // 3) tras submit de add-to-cart (por si no hay cambios de DOM detectables)
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (form && form.matches && form.matches('form[action^="/cart/add"]')) {
      setTimeout(ensureRecargoLine, 800);
    }
  });
})();
